import { formatDistance as o } from "./highrise1400.mjs";
import { formatLong as t } from "./highrise1401.mjs";
import { formatRelative as a } from "./highrise1402.mjs";
import { localize as r } from "./highrise1403.mjs";
import { match as e } from "./highrise1404.mjs";
const s = {
  code: "en-US",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
export {
  s as default,
  s as enUS
};
